<template>
  <div class="animated fadeIn">
    <basic-heading title="Projects">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'list project'">
      <template #gated-content>
        <b-row class="px-0 m-0 bg-light my-3">
          <b-col
            v-for="(indicator, index) in indicators"
            :class="`pl-0 pr-${index === 3 ? 0 : 3}`"
            :key="index"
          >
            <indicator-tile
              :text="indicator.text"
              :indicator_key="indicator.indicator_key"
              :faIcon="indicator.faIcon"
              :variant="indicator.variant"
            />
          </b-col>
        </b-row>
        <project-server-table :show_columns="columns" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import IndicatorTile from "@/components/shared/IndicatorTile";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import ProjectServerTable from "@/components/lab/project/ProjectServerTable";
import { AccessControlCheck } from "@/auth/AccessControlCheck";
import { project_indicators } from "@/shared/_indicators";

export default {
  name: "ProjectIndex",
  components: {
    BasicHeading,
    IndicatorTile,
    HeaderButtonGroup,
    PermissionAlertGate,
    ProjectServerTable,
  },
  data() {
    return {
      columns: [
        "pid",
        "customer.full_name",
        "sample_types",
        "test_packages",
        "turnarounds",
        "submission_count",
        "created_at",
        "received_percent",
        "prepped_percent",
        "scheduled_percent",
        "results_percent",
        "paid_at",
      ],
      indicators: project_indicators,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-plus",
            linkto: "/projects/add",
            title: "Add project",
            variant: "success",
            permission: this.checkPermission("add project"),
          },
        ],
      };
    },
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
  },
};
</script>
